import 'tinymce/icons/default'
import 'tinymce/themes/silver'
import '@/modules/common/editor/styles/tesmino-skin/skins/ui/tesmino-skin/skin.css'
import '@/modules/common/editor/styles/locales/fa/langs/fa'
import CustomContentStyle from '@/modules/common/editor/styles/custom-content-style'

const contentCssStylesheets = [
  '/build/css/custom-content.css'
]

const contentStyleStylesheets = [CustomContentStyle]

export const editorContentCss = () => contentCssStylesheets

export const editorContentStyle = () => contentStyleStylesheets.join('\n')
